export default "__VITE_ASSET__830806a3__"